export default __webpack_public_path__ + "static/media/import.3192eedb.svg";